import { Text } from "theme-ui";

import { Icon } from "./Icon";

export const ActionDescription: React.FC = ({ children }) => (
  <div className="flex flex-col justify-around mb-3 p-4">
    <div className="flex flex-row items-center">
      <Icon name="info-circle" size="sm" color='gray'/>
      <div className="ml-2 text-style-emphasize">{children}</div>
    </div>
  </div>
);

export const Amount: React.FC = ({ children }) => (
  <Text sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>{children}</Text>
);
